module.exports = __webpack_public_path__ + "static/media/VLORM_logo2.4cccf244.png";